<div class="info-section flex-1 p-2">
  <div class="flex flex-row justify-between items-center gap-2">
    <div class="flex flex-col">
      <div class="large-text">{{ count }}</div>
      <div class="xs-text">{{ text }}</div>
    </div>
    <div><img [src]="image" /></div>
  </div>
</div>
